import { Injectable } from '@angular/core';
import { format, setDay, setMonth, setYear } from 'date-fns';
import { ColumnDataTypes } from '../../database/models/column-data-types';
import { EditStyleModel } from '../../domain/dynamic-form/models/edit-style.model';
import { FUSION_DATE_TIME_FORMATTING } from '../constants/formatting';
import { DataAndTypeModel } from '../models';

@Injectable()
export class DateTimeService {
	// todo: use this in all places where we want current date
	public getCurrentDateTime(): Date {
		return new Date();
	}

	public getCurrentDateInFormat(dateFormat: string) {
		return format(new Date(), dateFormat);
	}

	public getEpochDate(): Date {
		return new Date('1900-01-01');
	}

	public getColumnDataType(editStyle: string, dataType: string | undefined): string {
		const columnDataType: string = dataType || ColumnDataTypes.CHAR;
		if (!editStyle) {
			return columnDataType;
		}

		if (editStyle.toLowerCase() === EditStyleModel.timeAmPm) {
			return ColumnDataTypes.TIME12;
		}
		if (editStyle.toLowerCase() === EditStyleModel.time24) {
			return ColumnDataTypes.TIME24;
		}

		return columnDataType;
	}

	public formatTimeFields(entryItems: DataAndTypeModel[]): DataAndTypeModel[] {
		return entryItems.map((item: DataAndTypeModel) => {
			if (item.valueType !== ColumnDataTypes.TIME12 && item.valueType !== ColumnDataTypes.TIME24) {
				return item;
			}

			item.value = this.fromFusionTimeFieldsFormat(item.value);
			return item;
		});
	}

	// input 1900-01-01 6:30:00 AM
	// output 1900-01-01T06:30:00 (slice from 1900-01-01T06:30:00.000Z)
	public fromFusionTimeFieldsFormat(datetime: string | undefined): string | undefined {
		if (!datetime) {
			return undefined;
		}

		// on iOS toISOString() return an error if date is separated by minus sign
		return new Date(`${datetime.replace(/-/g, '/')} UTC`).toISOString().slice(0, 19);
	}

	// input 1900-01-01T06:30:00
	// output 1900-01-01 6:30:00 AM
	public toFusionTimeFieldsFormat(datetime: string): string {
		const datetimeDate = new Date(datetime);

		setDay(datetimeDate, 1);
		setMonth(datetimeDate, 1);
		setYear(datetimeDate, 1900);

		return format(datetimeDate, FUSION_DATE_TIME_FORMATTING);
	}

	public getSystemDateTime(): string {
		const currentDateTimeInFusionFormat = this.getCurrentDateInFormat(FUSION_DATE_TIME_FORMATTING);
		return this.fromFusionTimeFieldsFormat(currentDateTimeInFusionFormat);
	}
}
